export class MemberDashboard {
    public TotalMembers: string = "";
    public TotalMembersChapterLevel: string = "";
    public Activemembers: string = "";
    public SNo: string = "";
    public MembersUnderGracePeriod: string = "";
    public ExpiredMemberships: string = "";
    public UsersLoggedinButNotMembers: string = "";
    public NewMembers: string = "";
    public PendingRequests: string = "";
    public ApprovedmemberPaymentPending: string = "";
}